<script>
	import { defineComponent } from 'vue';
	import axios from 'axios';
	import uniq  from 'lodash/uniq';

	const moment = require('moment');

	export default defineComponent({

		props: ['url'],

		data() {
			return {
				title:          '',
				results:        [],
				languages:      [],
				language:       'English',
				savedGuides:    [],
				guides:         [],
				guidesTaxonomy: [],
				guide:          '',
				term:           null
			};
		},
		methods:  {
			clearGuide(nodeValue) {
				// var index = this.savedGuides.indexOf(nodeValue);
				// if(index > -1) {
				// 	this.savedGuides.splice(index, 1);
				// }

				this.guide = '';
			},
			clearLanguage() {
				this.language = '';
			},
			clearAllFilters() {
				this.language    = '';
				this.guide       = '';
				this.savedGuides = '';
			}
		},
		created() {
			axios.get(this.url + '/wp-json/wp-json/v2/pocketGuidelines?per_page=100', {
				auth: {
					username: 'api',
					password: 'Astra123*'
				}
			})
				 .then(response => {
					 this.results = response.data;
					 this.results.forEach(result => {
						 this.languages.push(result.metaFields.language[0]);
					 });
					 return this.results;
				 })
				 .catch(function(error) {
					 console.log(error.response.data);
				 });
			axios.get(this.url + '/wp-json/wp/v2/guides', {
				auth: {
					username: 'api',
					password: 'Astra123*'
				}
			})
				 .then(response => {
					 let responseData = response.data;
					 if(typeof responseData == 'string') {
						 responseData        = responseData.replace('<!-- html is corrupted -->', '');
						 this.guidesTaxonomy = JSON.parse(responseData);
					 } else {
						 this.guidesTaxonomy = responseData;
					 }

					 this.guidesTaxonomy.forEach(guide => {
						 this.guides.push(guide.name);
					 });

					 return this.guides;
				 })
				 .catch(function(error) {
					 console.log(error.response.data);
				 });
		},
		computed: {
			filteredItems() {
				let checkIfGuidesExist = true;

				return this.results.filter(result => {
					if(this.guide !== '') {
						result.guidesTax.filter(guide => {
							if(guide === this.guide) {
								checkIfGuidesExist = true;
							} else {
								checkIfGuidesExist = false;
							}
						});

					}

					return (result.metaFields.language[0].indexOf(this.language) > -1)
						&& (result.metaFields.titleOriginal[0].toLowerCase()
															  .indexOf(this.title.toLowerCase()) > -1
							|| result.metaFields.content[0].toLowerCase()
														   .indexOf(this.title.toLowerCase()) > -1)
						&& checkIfGuidesExist;
				});

			},

			uniqueLanguages() {
				return uniq(this.languages);
			}
		},

		// watch: {
			// guide() {
			// 	if(this.savedGuides.indexOf(this.guide) === -1 && this.guide !== '') {
			// 		this.savedGuides.push(this.guide);
			// 		// this.guide = '';
			// 	}
			// }
		// },

		filters: {
			formatDate(value) {
				return moment(String(value))
					.format('MMM YYYY');
			}
		}

	});
</script>

<style lang="scss">
	.bb-pocket-container {
		padding: 0 15px;
		width: 100%;
		margin-right: auto;
		margin-left: auto;

		@media screen and (min-width: 499px) and (max-width: 767px) {
			max-width: 540px;
		}
		@media screen and (min-width: 768px) and (max-width: 991px) {
			max-width: 720px;
		}
		@media screen and (min-width: 992px) and (max-width: 1199px) {
			max-width: 960px;
		}
		@media screen and (min-width: 1200px) {
			max-width: 1168px;
		}
	}

	.bb-pocket-row {
		display: flex;
		flex-wrap: wrap;

		@media screen and (min-width: 768px) {
			margin: 0 -15px;
		}
	}

	.bb-pocket-row-search {
		display: flex;
		padding: 0 12px;

		@media screen and (max-width: 767px) {
			flex-wrap: wrap;
		}

		@media screen and (min-width: 768px) {
			margin: 0 -15px;
		}

	}

	.bb-pocket-row-search__item {
		@media screen and (max-width: 767px) {
			width: 100%;
		}

		@media screen and (min-width: 768px) {
			&:first-of-type {
				flex: 0 0 auto;
			}

			&:last-of-type {
				flex: 1;
			}
		}
	}

	.bb-pocket-filters {
		width: 100%;
		position: relative;
		background-color: #F3F3F3;
		padding: 15px 0 5px;

		input, select {
			height: 40px;
			border: 1px solid #DDDDDD;
			padding: 10px 40px 10px 10px;
			width: 100%;
			border-radius: 4px;
			background-color: #fff;
		}

		input {
			line-height: normal;
			-webkit-appearance:none;
		}

		select {
			background: #FFFFFF url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHdpZHRoPSIxNXB4IiBoZWlnaHQ9IjguNTUxcHgiIHZpZXdCb3g9Ii0xMDUuMDc3IDE3My45MDkgMTUgOC41NTEiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgLTEwNS4wNzcgMTczLjkwOSAxNSA4LjU1MSINCgkgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Zz4NCgk8cGF0aCBmaWxsPSIjNjY2NjY2IiBkPSJNLTk3LjU3NywxODIuNDU5Yy0wLjI2OSwwLTAuNTM4LTAuMTAzLTAuNzQzLTAuMzA4bC02LjQ1LTYuNDVjLTAuNDEtMC40MS0wLjQxLTEuMDc2LDAtMS40ODYNCgkJczEuMDc1LTAuNDEsMS40ODUsMGw1LjcwNyw1LjcwN2w1LjcwNy01LjcwN2MwLjQxLTAuNDEsMS4wNzUtMC40MSwxLjQ4NSwwczAuNDEsMS4wNzUsMCwxLjQ4NWwtNi40NSw2LjQ1DQoJCUMtOTcuMDQsMTgyLjM1Ny05Ny4zMDgsMTgyLjQ1OS05Ny41NzcsMTgyLjQ1OXoiLz4NCjwvZz4NCjwvc3ZnPg0K') right 15px center no-repeat;
			background-size: 12px;
			-moz-appearance: none;
			-webkit-appearance: none;
			appearance: none;
			position: relative;

			&::-ms-expand {
				display: none;
			}
		}
	}

	.bb-pocket-group {
		position: relative;
		padding: 0 7.5px;
		margin-bottom: 10px;

		@media screen and (max-width: 499px) {
			width: 100%;
		}

		@media screen and (min-width: 500px) and (max-width: 767px) {
			width: 50%;
		}

		@media screen and (min-width: 768px) {
			width: 25%;
		}
	}

	.bb-pocket-group--dropdown {
		&:before {
			content: '';
			width: 1px;
			height: 25px;
			background-color: #DDDDDD;
			position: absolute;
			right: 48px;
			z-index: 1;
			top: 0;
			bottom: 0;
			margin: auto;
		}
	}

	.bb-pocket__search {
		width: 40px;
		height: 40px;
		border: none;
		box-shadow: none;
		position: absolute;
		top: 0;
		right: 7.5px;
		background: transparent url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHdpZHRoPSIzNXB4IiBoZWlnaHQ9IjM1LjAwOHB4IiB2aWV3Qm94PSItMTI3LjEyNiA1Ny41MDQgMzUgMzUuMDA4IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IC0xMjcuMTI2IDU3LjUwNCAzNSAzNS4wMDgiDQoJIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGc+DQoJPHBhdGggZmlsbD0iIzY2NjY2NiIgZD0iTS05Mi40MjksOTAuNzI3bC04LjUwOC04LjUwOGMyLjI4Mi0yLjYyMywzLjY2NC02LjA0NywzLjY2NC05Ljc4N2MwLTguMjM2LTYuNjk5LTE0LjkyOC0xNC45MjctMTQuOTI4DQoJCWMtOC4yMzYsMC0xNC45MjcsNi42OTktMTQuOTI3LDE0LjkyOHM2LjY5OSwxNC45MjYsMTQuOTI3LDE0LjkyNmMzLjc0MSwwLDcuMTY0LTEuMzgxLDkuNzg4LTMuNjYybDguNTA4LDguNTA2DQoJCWMwLjIwMiwwLjIwMywwLjQ3NCwwLjMxMSwwLjczNywwLjMxMXMwLjUzNS0wLjEsMC43MzctMC4zMTFDLTkyLjAyNSw5MS43OTktOTIuMDI1LDkxLjEzMS05Mi40MjksOTAuNzI3eiBNLTEyNS4wMzgsNzIuNDMyDQoJCWMwLTcuMDgsNS43Ni0xMi44MzIsMTIuODMxLTEyLjgzMmM3LjA3OSwwLDEyLjgzMSw1Ljc2LDEyLjgzMSwxMi44MzJjMCw3LjA3LTUuNzUyLDEyLjgzOC0xMi44MzEsMTIuODM4DQoJCUMtMTE5LjI3OCw4NS4yNy0xMjUuMDM4LDc5LjUxLTEyNS4wMzgsNzIuNDMyeiIvPg0KPC9nPg0KPC9zdmc+DQo=') center no-repeat;
		background-size: 20px;
	}

	.bb-pocket-search {
		align-items: center;
		padding: 15px 0 7px 0;
		border-bottom: 1px solid #DDD;
	}

	.bb-pocket-search__active {
		font-weight: bold;
		display: inline-block;
		margin: 0 15px 8px 0;
	}

	.bb-pocket-search__item {
		background: #FFFFFF;
		font-size: 12px;
		font-weight: bold;
		display: inline-flex;
		border: 1px solid #DDDDDD;
		border-radius: 32px;
		padding: 3px 5px 3px 10px;
		margin-bottom: 8px;

		&:not(:last-of-type) {
			margin-right: 8px;
		}
	}

	.bb-pocket-search__remove {
		width: 16px;
		height: 16px;
		position: relative;
		background-color: #DDDDDD;
		border-radius: 50%;
		margin-left: 8px;

		&:hover {
			background-color: #555555;
		}

		&:before, &:after {
			content: '';
			width: 8px;
			height: 1px;
			background-color: #fff;
			position: absolute;
			left: 0;
			right: 0;
			bottom: 0;
			top: 0;
			margin: auto;
		}

		&:before {
			transform: rotate(45deg);
		}

		&:after {
			transform: rotate(-45deg);
		}
	}

	.bb-pocket-search__clear {
		font-weight: bold;
		text-decoration: underline;
		display: inline-block;
		margin-left: 10px;
		margin-bottom: 8px;
	}

	.bb-pocket-content {
		padding: 30px 0;
	}

	.bb-pocket-item {
		padding: 0 7.5px;
		margin-bottom: 30px;

		a {
			text-decoration: none;
			display: block;
		}

		h4 {
			color: #000;
			margin: 0 0 8px;
		}
	}

	.bb-pocket-item__img {
		position: relative;
		width: 100%;
		height: 0;
		padding-bottom: 56.25%;
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center;
		margin-bottom: 8px;
	}

	.bb-pocket-item__title-original {
		color: #666666;
		margin-bottom: 2px;
	}

	.bb-pocket-item__posted {
		color: rgb(102, 102, 102);
		font-size: 12px;

		span {
			font-weight: bold;
		}
	}

	.bb-pocket-item__content {
		font-size: 14px;
		color: #000;
		margin-bottom: 8px;
	}
</style>